<template>
    <v-dialog v-model="show" width="500" persistent>
        <v-card>
            <div class="fti-dialog-header">
                <div class="ml-3">{{ $t('sendConversationToEmail') | capitalize }}</div>
                <v-spacer></v-spacer>
                <v-btn flat icon @click="close()">
                    <v-icon color="#fff">mdi-close</v-icon>
                </v-btn>
            </div>
            <div style="padding: 12px">
                <v-text-field
                    solo
                    background-color="#F7F7FC"
                    flat v-model="title"
                    maxlength="200"
                    counter
                  >
                </v-text-field>
                <v-textarea
                    v-model="notes"
                    solo
                    background-color="#F7F7FC"
                    flat
                    :placeholder="$t('enterNoteSendEmail') | capitalize"
                    maxlength="500"
                    counter
                ></v-textarea>
            </div>
            <v-layout justify-center>
                <v-btn color="#F7722F" dark @click="sendEmailConversation()" class="fti-btn">
                    {{ $t('sendToEmail') }}
                </v-btn>
            </v-layout>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "DialogSendConversationToEmail",
    data () {
        return {
            show: false,
            notes: '',
            botCode: '',
            senderId: '',
            livesupport_log: '',
            title: ''
        }
    },
    methods: {
        open (botCode, senderId, livesupport_log, title) {
            this.botCode = botCode
            this.senderId = senderId
            this.livesupport_log = livesupport_log
            this.show = true
            this.title = title
        },
        close () {
            this.show = false
        },
        sendEmailConversation () {
            let url = `live-support/send-email-conversation/${this.botCode}/${this.senderId}/`;
            let live_support_log_session_id = this.livesupport_log ? this.livesupport_log.session_id : null;
            this.$http.post(url, {
                "title": this.title,
                "comment": this.notes,
                "live_support_log_session_id": live_support_log_session_id
            }).then(
                () => {
                    this.notes = ''
                    this.close()
                    this.$AppService.toast(
                        "The conversation has been sent to email",
                        'info',
                        5000
                    );
                }
            )
        }
    }
}
</script>

<style scoped lang="scss">
    .fti-dialog-header {
        display: flex;
        align-items: center;
        background: #0052CC;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        height: 40px;
    }
    .fti-btn {
        text-transform: capitalize;
        font-weight: bold;
        margin: 0 0 12px 0;
    }
</style>
